import { useCallback } from 'react'
import { MEETINGS_SETTINGS_TAB } from '@shared/settings/settings-deeplink'
import { useOpenSettingsTab } from './use-open-settings-tab'

/** Opens the Settings window on the Meetings tab — the target of every "Settings → Meetings" link. */
export function useOpenMeetingsSettings() {
  const openSettingsTab = useOpenSettingsTab()
  return useCallback(() => openSettingsTab(MEETINGS_SETTINGS_TAB), [openSettingsTab])
}
